export default function classesToSelector(){var classes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return".".concat(classes.trim().replace(/([\.:!\/])/g,'\\$1')// eslint-disable-line
.replace(/ /g,'.'));}